/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ChevronsLeftIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M6.968 18.906 18.962 6.97c.562-.625 1.499-.625 2.123 0 .563.562.563 1.5 0 2.062L10.092 19.97l10.93 11a1.37 1.37 0 0 1 0 2.062c-.561.625-1.498.625-2.06 0l-11.994-12c-.624-.562-.624-1.5 0-2.125m23.987-12v.063c.562-.625 1.499-.625 2.123 0 .563.562.563 1.5 0 2.062l-10.993 11 10.93 10.938a1.37 1.37 0 0 1 0 2.062c-.561.625-1.498.625-2.06 0l-11.993-12c-.625-.562-.625-1.5 0-2.125z"/>}
        </IconWrapper>);
}
